// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"29939f1c","453":"8895529f","455":"2eb44717"}[chunkId] + ".chunk.js";
};